import { RefObject } from 'react';

import store from '../../redux/store';
import { closeModal } from '../../redux/actions';

export const handleModal = (ref: RefObject<HTMLElement | null>) => {
  ref?.current?.classList.add('hide-modal');
  setTimeout(() => store.dispatch(closeModal()), 300);
};
